export default {
  id: 'tag.assetId',
  name: 'tag.assetId',
  displayName: 'Go To Asset',
  valueType: 'string',
  objectType: 'tag',
  get: obj => {
    return obj?.data?.asset?.id;
  }
};